import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';

@Component({
  selector: 'clearbit-logo',
  templateUrl: './clearbit-logo.component.html',
  styleUrls: ['./clearbit-logo.component.scss']
})
export class ClearbitLogoComponent implements OnInit, OnChanges {

  @Input() domain: string;
  @Input() height: number;
  @Input() width: number;
  @Input() greyscale: boolean;

  src: string ='../../../../assets/images/no-logo.png';

  constructor() {}

  ngOnInit(): void {
    this.updateImageSrc();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.domain || changes.greyscale) {
      this.updateImageSrc();
    }
  }

  updateImageSrc(): void {
    if (this.domain || this.domain !== '' || this.domain !== null || this.domain !== undefined) {
      const baseUrl = `https://logo.clearbit.com/${this.domain}?size=`+this.width;
      const greyscaleParam = this.greyscale ? '&greyscale=true' : '';
      this.src = baseUrl + greyscaleParam;
    } else {
      this.src = '../../../../assets/images/no-logo.png';
    }
  }

  errorHandler(event: Event): void {
    const imgElement = event.target as HTMLImageElement;
    imgElement.src = `../../../../assets/images/no-logo.png`;
  }
}
